/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateServiceordreRequestDto as OkEgisServiceModelsDtoCreateServiceordreRequestDto } from '../models/OK/Egis/Service/Models/DTO/create-serviceordre-request-dto';
import { OpgaveTypeDto as OkEgisServiceModelsDtoOpgaveTypeDto } from '../models/OK/Egis/Service/Models/DTO/opgave-type-dto';
import { PartnerInfoDto as OkEgisServiceModelsDtoPartnerInfoDto } from '../models/OK/Egis/Service/Models/DTO/partner-info-dto';
import { ResendServiceordredRequestDto as OkEgisServiceModelsDtoResendServiceordredRequestDto } from '../models/OK/Egis/Service/Models/DTO/resend-serviceordred-request-dto';
import { ServiceordreDto as OkEgisServiceModelsDtoServiceordreDto } from '../models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { ServiceordreWithAfregningResponseDto as OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto } from '../models/OK/Egis/Service/Models/DTO/serviceordre-with-afregning-response-dto';
import { UpdateServiceordreRequestDto as OkEgisServiceModelsDtoUpdateServiceordreRequestDto } from '../models/OK/Egis/Service/Models/DTO/update-serviceordre-request-dto';
import { AfvisPosteringerForServiceordreRequest as OkEgisServiceModelsRequestAfvisPosteringerForServiceordreRequest } from '../models/OK/Egis/Service/Models/Request/afvis-posteringer-for-serviceordre-request';
import { ChangeOrdreOpgaveTypeRequest as OkEgisServiceModelsRequestChangeOrdreOpgaveTypeRequest } from '../models/OK/Egis/Service/Models/Request/change-ordre-opgave-type-request';
import { GetServiceordrerRequest as OkEgisServiceModelsRequestGetServiceordrerRequest } from '../models/OK/Egis/Service/Models/Request/get-serviceordrer-request';
import { HandleKreditstopRequest as OkEgisServiceModelsRequestHandleKreditstopRequest } from '../models/OK/Egis/Service/Models/Request/handle-kreditstop-request';
import { HandleValidationFailedRequest as OkEgisServiceModelsRequestHandleValidationFailedRequest } from '../models/OK/Egis/Service/Models/Request/handle-validation-failed-request';
import { GetServiceordrerResponse as OkEgisServiceModelsResponseGetServiceordrerResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceordrer-response';

@Injectable({
  providedIn: 'root',
})
export class ServiceordreService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getServiceordrer
   */
  static readonly GetServiceordrerPath = '/api/v1/Serviceordre/GetServiceordrer';

  /**
   * Get all serviceordrer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordrer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceordrer$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceordrerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordrerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetServiceordrerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordrerResponse>;
      })
    );
  }

  /**
   * Get all serviceordrer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordrer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceordrer(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceordrerRequest
  }): Observable<OkEgisServiceModelsResponseGetServiceordrerResponse> {

    return this.getServiceordrer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordrerResponse>) => r.body as OkEgisServiceModelsResponseGetServiceordrerResponse)
    );
  }

  /**
   * Path part for operation createServiceordre
   */
  static readonly CreateServiceordrePath = '/api/v1/Serviceordre/CreateServiceordre';

  /**
   * Creates a new Serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceordreRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.CreateServiceordrePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>;
      })
    );
  }

  /**
   * Creates a new Serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceordreRequestDto
  }): Observable<OkEgisServiceModelsDtoServiceordreDto> {

    return this.createServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>) => r.body as OkEgisServiceModelsDtoServiceordreDto)
    );
  }

  /**
   * Path part for operation resendServiceordre
   */
  static readonly ResendServiceordrePath = '/api/v1/Serviceordre/ResendServiceordre';

  /**
   * Resends a Serviceordre by rejeting the first and creating a new.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resendServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resendServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * New resendTilkaldRequestDto
     */
    body?: OkEgisServiceModelsDtoResendServiceordredRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.ResendServiceordrePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Resends a Serviceordre by rejeting the first and creating a new.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resendServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resendServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * New resendTilkaldRequestDto
     */
    body?: OkEgisServiceModelsDtoResendServiceordredRequestDto
  }): Observable<void> {

    return this.resendServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resendServiceordreToPartner
   */
  static readonly ResendServiceordreToPartnerPath = '/api/v1/Serviceordre/ResendServiceordreToPartner/{serviceordreEntityId}';

  /**
   * Resends a Serviceordre as-is to partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resendServiceordreToPartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendServiceordreToPartner$Response(params: {

    /**
     * serviceordreEntityId
     */
    serviceordreEntityId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.ResendServiceordreToPartnerPath, 'post');
    if (params) {
      rb.path('serviceordreEntityId', params.serviceordreEntityId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Resends a Serviceordre as-is to partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resendServiceordreToPartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendServiceordreToPartner(params: {

    /**
     * serviceordreEntityId
     */
    serviceordreEntityId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.resendServiceordreToPartner$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getServiceordrerForServiceaftale
   */
  static readonly GetServiceordrerForServiceaftalePath = '/api/v1/Serviceordre/GetServiceordrer/{serviceaftaleNo}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordrerForServiceaftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordrerForServiceaftale$Response(params: {
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetServiceordrerForServiceaftalePath, 'get');
    if (params) {
      rb.path('serviceaftaleNo', params.serviceaftaleNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordrerForServiceaftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordrerForServiceaftale(params: {
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceordreDto>> {

    return this.getServiceordrerForServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceordreDto>)
    );
  }

  /**
   * Path part for operation getServiceordre
   */
  static readonly GetServiceordrePath = '/api/v1/Serviceordre/GetServiceordre';

  /**
   * Henter en serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordre$Response(params: {

    /**
     * Serviceordre nummer
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetServiceordrePath, 'get');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>;
      })
    );
  }

  /**
   * Henter en serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordre(params: {

    /**
     * Serviceordre nummer
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceordreDto> {

    return this.getServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>) => r.body as OkEgisServiceModelsDtoServiceordreDto)
    );
  }

  /**
   * Path part for operation cancelServiceordre
   */
  static readonly CancelServiceordrePath = '/api/v1/Serviceordre/CancelServiceordre';

  /**
   * Annullerer en serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelServiceordre$Response(params: {

    /**
     * ServiceordreNo
     */
    serviceordreNo?: number;
    note?: string;
    resendToNewPatner?: boolean;
    newPartnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.CancelServiceordrePath, 'put');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.query('note', params.note, {});
      rb.query('resendToNewPatner', params.resendToNewPatner, {});
      rb.query('newPartnerNo', params.newPartnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Annullerer en serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelServiceordre(params: {

    /**
     * ServiceordreNo
     */
    serviceordreNo?: number;
    note?: string;
    resendToNewPatner?: boolean;
    newPartnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.cancelServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation afvisPosteringerForServiceordre
   */
  static readonly AfvisPosteringerForServiceordrePath = '/api/v1/Serviceordre/AfvisPosteringerForServiceordre';

  /**
   * Afvis posteringer for en serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `afvisPosteringerForServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  afvisPosteringerForServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Request
     */
    body?: OkEgisServiceModelsRequestAfvisPosteringerForServiceordreRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.AfvisPosteringerForServiceordrePath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Afvis posteringer for en serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `afvisPosteringerForServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  afvisPosteringerForServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Request
     */
    body?: OkEgisServiceModelsRequestAfvisPosteringerForServiceordreRequest
  }): Observable<void> {

    return this.afvisPosteringerForServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation approveForAccountingServiceordre
   */
  static readonly ApproveForAccountingServiceordrePath = '/api/v1/Serviceordre/ApproveServiceordre';

  /**
   * Godkender en serviceordre til fakturering.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveForAccountingServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveForAccountingServiceordre$Response(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.ApproveForAccountingServiceordrePath, 'put');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Godkender en serviceordre til fakturering.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approveForAccountingServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveForAccountingServiceordre(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.approveForAccountingServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation requeueForAccounting
   */
  static readonly RequeueForAccountingPath = '/api/v1/Serviceordre/RequeueForAccounting';

  /**
   * Requeues a failed serviceordre for accounting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requeueForAccounting()` instead.
   *
   * This method doesn't expect any request body.
   */
  requeueForAccounting$Response(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.RequeueForAccountingPath, 'put');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Requeues a failed serviceordre for accounting.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `requeueForAccounting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  requeueForAccounting(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.requeueForAccounting$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation handleValidationFailed
   */
  static readonly HandleValidationFailedPath = '/api/v1/Serviceordre/HandleValidationFailed';

  /**
   * Requeues a failed serviceordre for accounting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `handleValidationFailed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  handleValidationFailed$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Serviceordreno and new state
     */
    body?: OkEgisServiceModelsRequestHandleValidationFailedRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.HandleValidationFailedPath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Requeues a failed serviceordre for accounting.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `handleValidationFailed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  handleValidationFailed(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Serviceordreno and new state
     */
    body?: OkEgisServiceModelsRequestHandleValidationFailedRequest
  }): Observable<void> {

    return this.handleValidationFailed$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retractApproval
   */
  static readonly RetractApprovalPath = '/api/v1/Serviceordre/RetractApproval';

  /**
   * Removes approval for a given serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retractApproval()` instead.
   *
   * This method doesn't expect any request body.
   */
  retractApproval$Response(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.RetractApprovalPath, 'put');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>;
      })
    );
  }

  /**
   * Removes approval for a given serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retractApproval$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retractApproval(params: {

    /**
     * Serviceordreno
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceordreDto> {

    return this.retractApproval$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>) => r.body as OkEgisServiceModelsDtoServiceordreDto)
    );
  }

  /**
   * Path part for operation getServiceordreWithAfregningsInfo
   */
  static readonly GetServiceordreWithAfregningsInfoPath = '/api/v1/Serviceordre/GetServiceordreWithAfregningsInfo';

  /**
   * Henter en serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordreWithAfregningsInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordreWithAfregningsInfo$Response(params: {

    /**
     * Serviceordre nummer
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetServiceordreWithAfregningsInfoPath, 'get');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>;
      })
    );
  }

  /**
   * Henter en serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordreWithAfregningsInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordreWithAfregningsInfo(params: {

    /**
     * Serviceordre nummer
     */
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto> {

    return this.getServiceordreWithAfregningsInfo$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>) => r.body as OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto)
    );
  }

  /**
   * Path part for operation updateServiceordre
   */
  static readonly UpdateServiceordrePath = '/api/v1/Serviceordre/UpdateServiceordre';

  /**
   * Updated an existing service ordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceordreRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.UpdateServiceordrePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>;
      })
    );
  }

  /**
   * Updated an existing service ordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceordreRequestDto
  }): Observable<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto> {

    return this.updateServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto>) => r.body as OkEgisServiceModelsDtoServiceordreWithAfregningResponseDto)
    );
  }

  /**
   * Path part for operation getServiceordreOpgaveTyper
   */
  static readonly GetServiceordreOpgaveTyperPath = '/api/v1/Serviceordre/GetServiceordreOpgaveTyper';

  /**
   * Henter mulige opgavetyper for en serviceordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordreOpgaveTyper()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordreOpgaveTyper$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoOpgaveTypeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetServiceordreOpgaveTyperPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoOpgaveTypeDto>>;
      })
    );
  }

  /**
   * Henter mulige opgavetyper for en serviceordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordreOpgaveTyper$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceordreOpgaveTyper(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoOpgaveTypeDto>> {

    return this.getServiceordreOpgaveTyper$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoOpgaveTypeDto>>) => r.body as Array<OkEgisServiceModelsDtoOpgaveTypeDto>)
    );
  }

  /**
   * Path part for operation handleKreditstop
   */
  static readonly HandleKreditstopPath = '/api/v1/Serviceordre/HandleKreditstop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `handleKreditstop()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  handleKreditstop$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHandleKreditstopRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.HandleKreditstopPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `handleKreditstop$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  handleKreditstop(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHandleKreditstopRequest
  }): Observable<void> {

    return this.handleKreditstop$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation changeOpgaveType
   */
  static readonly ChangeOpgaveTypePath = '/api/v1/Serviceordre/ChangeOpgaveType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeOpgaveType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOpgaveType$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestChangeOrdreOpgaveTypeRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.ChangeOpgaveTypePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changeOpgaveType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOpgaveType(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestChangeOrdreOpgaveTypeRequest
  }): Observable<OkEgisServiceModelsDtoServiceordreDto> {

    return this.changeOpgaveType$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceordreDto>) => r.body as OkEgisServiceModelsDtoServiceordreDto)
    );
  }

  /**
   * Path part for operation getPartnerInfoForServiceordre
   */
  static readonly GetPartnerInfoForServiceordrePath = '/api/v1/Serviceordre/GetPartnerInfoForServiceordre';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerInfoForServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInfoForServiceordre$Response(params: {
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreService.GetPartnerInfoForServiceordrePath, 'get');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerInfoForServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInfoForServiceordre(params: {
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerInfoDto> {

    return this.getPartnerInfoForServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>) => r.body as OkEgisServiceModelsDtoPartnerInfoDto)
    );
  }

}
